// empty-stablelib-random.js
module.exports = {
    randomBytes: (length = 32) => {
        return new Uint8Array(length)
    },
    randomInt: () => {
        return 0
    },
}
